<template>
  <div style="width: 100%;height: 100%;position: relative">
    <el-button @click="backBtn" type="primary" style="margin: 20px">返回</el-button>
    <div :style="bgImg" style="position: absolute;left: 0;">
      <div style="position: absolute;width: 420px;left: 175px;top: 120px;height: 850px;overflow:auto">
        <div v-if="details.type === '1'">
          <div style="font-size: 28px;color: #333;padding: 30px">{{ details.news_title }}</div>
          <div style="display: flex;justify-content: space-between;align-items: center">
            <div style="display: flex">
              <el-avatar style="margin-left: 20px;margin-right: 10px" :src="details.head_img_url"></el-avatar>
              <div style="display: flex;flex-direction: column">
                <div>{{ details.nickname }}</div>
                <div>{{ '阅读数：' + details.watch_count }}</div>
              </div>
            </div>
          </div>
          <div style="margin-left: 70px;color:#889EA4;">{{ details.create_date + ' 发布' }}</div>
          <div style="padding: 20px;text-indent: 2em">{{details.zhaiyao}}</div>
          <div style="padding: 20px;" v-html="details.news_content"></div>
          <div style="height: 100px"></div>
        </div>
        <div v-else-if="details.type === '2'">
          <div style="display: flex;justify-content: center;margin-top: 12px">
            <video-player style="width: 100%;height: 100%;" class="video-player vjs-custom-skin"
                          ref="videoPlayer"
                          :playsinline="true"
                          :options="playerOptions">
            </video-player>
          </div>
          <div style="font-size: 28px;color: #333;padding: 12px 12px 0 12px">{{ details.news_title }}</div>
          <div style="margin-left: 16px;margin-top: 16px">{{ details.create_date + ' 发布' }}</div>
          <div
              style="display: flex;justify-content: space-between;align-items: center;background-color: #f1f1f1;margin: 16px;padding: 12px 0">
            <div style="display: flex">
              <el-avatar style="margin-left: 20px;margin-right: 10px" :src="details.head_img_url"></el-avatar>
              <div style="display: flex;flex-direction: column">
                <div>{{ details.nickname }}</div>
                <div>{{ '阅读数：' + details.watch_count }}</div>
              </div>
            </div>
          </div>
          <div style="padding: 0 20px;text-indent: 2em">{{details.zhaiyao}}</div>
        </div>
      </div>
    </div>
    <div :style="logoImg" style="position: absolute;left: 700px;top: 520px;">
    </div>
  </div>
</template>

<script>

const url = require("../../assets/image/preview_bg.png");
const logo = require("../../assets/image/preview_logo.png");

export default {
  data() {
    return {
      id: '',
      bgImg: {
        backgroundImage: "url(" + url + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "80%",
        width: "935px",
        height: "1100px"
      },
      logoImg: {
        backgroundImage: "url(" + logo + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "10%",
        width: "100%",
        height: "100%"
      },
      details: {},
      bannerIndex:0,
      bannerText:'',
      playerOptions: {
        //播放速度
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        //如果true,浏览器准备好时开始回放。
        autoplay: false,
        // 默认情况下将会消除任何音频。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: 'auto',
        language: 'zh-CN',
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: '16:9',
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        sources: [{
          //类型
          type: "video/mp4",
          //url地址
          src: ''
        }],
        //你的封面地址
        poster: '',
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          //全屏按钮
          fullscreenToggle: true
        }
      }
    };
  },
  created() {
    this.id = this.$route.query.id
    if (this.id) {
      this.getAxios("/handNewsInfo/getOneHandNewsInfoById?id=" + this.id, {}).then(res => {
        if (res.success) {
          this.details = res.entity
          if (this.details) {
            if (this.details.news_content) {
              if (this.details.type === '1'){
                this.details.news_content = this.details.news_content.replace(/\<img/gi, '<img style="max-width:100%;height:auto" ')
              }else{
                this.playerOptions.sources[0].src = this.details.news_content
              }
            }
          }
        }
      })
    }
  },
  methods: {
    backBtn() {
      this.$router.back()
    },
    bannerChange(e){
      this.bannerText = this.details.newsImgSubList[e].imgText
      console.log('e',e)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-carousel {
  width: 100%;
  height: 240px;
}
</style>
